export const cyan = {
  300: 'hsla(187, 71%, 59%, 1)',
  400: 'hsla(186.67, 70.87%, 50.20%, 1)',
};

export type CyanPalette = typeof cyan;
